/* eslint-disable no-unused-vars */
import React from 'react';
import NonCli from '../../assets/img/Home/Rectangle 4611.png';
import overlayImg from "../../assets/img/Login/Rectangle 4621.png";
import JobUpdates from '../../component/JobUpdates';
import Footer from '../../component/Footer';
import HeaderHome from '../../component/HeaderHome';
import { useNavigate } from 'react-router-dom';
import tableImage from "../../../src/assets/img/Services/image 41.png";
import Admin from "../../../src/assets/img/Services/admin.jpg";
import IT from "../../../src/assets/img/Services/IT.jpg";
import Ancillary from "../../../src/assets/img/Services/ancillary.jpg";
import NonClinicalBanner from '../../../src/assets/img/Services/Banner image for clinical service for the website (1).png'
import ServiveImg from '../../../src/assets/img/Services/Frame 8480 (1).png'
import patternImg1 from '../../../src/assets/img/Services/red-swirl (1).png'



function NonClinical() {
    const navigate = useNavigate();

    const handleClickNonClinicalPermanent = () => {
        navigate('/JobsPage?Sector=NON Clinical&JobType=Permanent');
        window.scrollTo(0, 0);
      };

    const handleClickNonClinicalTemporary = () => {
        navigate('/JobsPage?Sector=NON Clinical&JobType=Contract');
        window.scrollTo(0, 0);
      };

  return (
    <div className='bg-[#F9F9FA] overflow-x-hidden'>
      <HeaderHome />
         <div className="relative mt-8">
  <img
    className="w-full min-h-[298px] bottom-0 object-cover z-0 pointer-events-none"
    src={NonClinicalBanner}
    alt="Vacancy Background"
  />

  <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-4">
  <h1 className="text-center tracking-wider font-oregon_black font-medium text-[28px] sm:text-[30px] md:text-[30px] lg:text-[30px] leading-tight">
    Non Clinical
  </h1>

  <p className="mt-4 sm:mt-6 tracking-wider font-oregon_black  font-medium text-[18px] sm:text-[20px] md:text-[24px] lg:text-[30px] leading-snug sm:leading-normal text-center sm:text-left max-w-[90%] sm:max-w-2xl lg:max-w-4xl lg:mr-36 sm:mr-20">
    Innovative Services and Solutions for a Healthier Tomorrow
  </p>
</div>

</div>
      <div className="mt-16 mx-auto px-4 lg:px-[50px] justify-center w-full h-full">
        <div className="w-full">
          {/* <div data-aos="zoom-in" className="relative w-full flex items-center justify-center">
          <div className="relative w-full h-full flex items-center justify-center">
          <div className='absolute text-[#FFFFFF] text-[24px] sm:text-[50px] md:text-[70px] lg:text-[90px] font-normal z-20'>Non-Clinical</div>
            <img src={NonCli} alt="Login" className='w-full h-full' />
            <div className="absolute inset-0 bg-transparent">
              <img src={overlayImg} alt="Overlay" className="rounded-xl w-full h-full" />
            </div>
          </div>
        </div> */}
        <div className='my-[50px]  mx-auto  flex flex-col lg:grid lg:grid-cols-[56%_44%]  gap-x-10 w-full'>
          <div className=''>
              <h3 data-aos="fade-up" className="mt-12 xl:whitespace-nowrap md:whitespace-normal mb-2 service-text1 text-center">NHS Workforce Alliance -<span className="text-[#0082DA]">Non Clinical Framework</span></h3>
          <p data-aos="zoom-in" className="text-left mt-12 text-3-corpo-soft">As a trusted partner on the NHS WFA Non-Clinical framework, we proudly provide flexible workers across essential staff groups, including Admin & Clerical, IT Professionals, Estates, Facilities Management, and Ancillary Staff. Our extensive network of dedicated professionals ensures that your staffing needs are met promptly and efficiently, allowing for seamless operations and uninterrupted patient care.</p>
          </div>
<div className="relative w-full max-w-5xl mx-auto overflow-hidden">
  {/* Background Pattern */}
  <img
    src={patternImg1}
    alt="patternImage"
    className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none"
  />

  {/* Foreground Image */}
  <img
    src={ServiveImg}
    alt="ServiceImage"
    className="relative z-10 object-cover pointer-events-none mt-16 md:mt-32 lg:mt-10  w-full max-w-[90%] sm:max-w-[650px]  mx-auto"
  />
</div>

        </div>
       <div>
         {/* <p data-aos="zoom-in" className="text-3 mt-12 font-bold text-center"><span className="home-text">Lot 1 Admin & Clerical</span></p>
          <div className="mt-8 w-full h-auto sm:w-3/4 sm:h-auto md:w-1/2 lg:w-2/3 mx-auto">
        <img src={Admin} alt="Admin" className="w-full h-auto object-cover" />
        </div>
          <p data-aos="zoom-in" className="text-3 mt-16 font-bold text-center"><span className="home-text">Lot 3 IT Professionals</span></p>
          <div className="mt-8 w-full h-auto sm:w-3/4 sm:h-auto md:w-1/2 lg:w-2/3 mx-auto">
          <img src={IT} alt="IT" className="w-full h-auto object-cover" />
          </div>
          <p data-aos="zoom-in" className="text-3 mt-16 font-bold text-center"><span className="home-text">Lot 6 Estates, Facilities Management, and Ancillary Staff</span></p>
          <div className="mt-8 w-full h-auto sm:w-3/4 sm:h-auto md:w-1/2 lg:w-2/3 mx-auto">
          <img src={Ancillary} alt="Ancillary" className="w-full h-auto object-cover" />
        </div> */}
          <div className="mt-16 mb-10">
              <img src={tableImage} alt="table" className="w-full h-full pointer-events-none" />
            </div>
       </div>
         
          {/* <div data-aos="zoom-in" className='mt-12'>
        <button 
        onClick={handleClickNonClinicalPermanent} 
        className="bg-[#0082DA] text-2 font-bold py-2 px-5 lg:py-3 lg:px-6 rounded">
        Permanent Non-Clinical Jobs
        </button>
        <div data-aos="zoom-in" className='mt-12'>
        <button 
        onClick={handleClickNonClinicalTemporary} 
        className="bg-[#0082DA] text-2 font-bold py-2 px-5 lg:py-3 lg:px-6 rounded">
        Temporary Non-Clinical Jobs
        </button>
        </div>
        </div> */}
        </div>
        {/* <div className="mt-16 w-full text-center">
        <h3 data-aos="fade-up" className="font-bold text-5 mb-2"><span className=""></span></h3>
          <p data-aos="zoom-in" className="text-3 mt-12">As a proud and preferred supplier of the Nonclinical framework provided by the Crown Commercial Service, RHC 360 Solutions provides extensive support towards the nonclinical staffing requirements of the NHS, Care Homes and other organisations. Our candidates range from administrative, clerical, IT, hospitality, catering, maintenance and logistics related backgrounds, with over two years experience in clinical or nonclinical settings.</p>          
        </div> */}
      </div>
      {/* <div className="mx-[40px] my-[100px]">
        <JobUpdates />
      </div> */}
      <Footer />
    </div>
  );
}

export default NonClinical;
